import React from 'react';
import { Button, Dialog } from '@biq/apex-ui';
import {
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    Typography,
} from '@mui/material';
import { LifeGraphLogo } from '../../assets';
import { useZone } from '../../core';
import { useServerInfo } from '../../hooks/useServerInfo';
import { default as AppVersionData } from '../../version.json';
import { appVersionModalStyles } from './app-version-modal-helper';

interface AppVersionModalProps {
    onClose: () => void;
}
export const AppVersionModal = ({
    onClose,
}: AppVersionModalProps): React.JSX.Element => {
    const { data: serverInfo } = useServerInfo();
    const { getSelectedDataZone } = useZone();

    //BIQ_SDZ_NAME
    const selectedEnvName = getSelectedDataZone()?.sdz.toUpperCase();

    // UI Version: Real value gets compiled during deployment; this will always show 0.0.1 running locally.
    const appVersion = AppVersionData.version ?? 'N/A';

    // UI Library Version: Gets the Apex Library version from the installed package.json dependency.
    const libraryVersion =
        require('@biq/apex-ui/package.json').version ?? 'N/A';

    // Server version
    const serverVersion: string = serverInfo?.build?.version ?? 'N/A';

    const handleClose = (): void => {
        onClose();
    };

    return (
        <Dialog
            open={true}
            closable={true}
            onClose={handleClose}
            sx={appVersionModalStyles.root}
        >
            <DialogTitle />
            <Grid sx={appVersionModalStyles.logoContainer}>
                <Grid>
                    <img
                        src={LifeGraphLogo}
                        alt='burst-logo'
                        style={appVersionModalStyles.dialogIcon}
                    />
                </Grid>
            </Grid>
            <DialogContent sx={appVersionModalStyles.dialogBodyContainer}>
                <Typography sx={appVersionModalStyles.aboutLabel}>
                    About {selectedEnvName}
                </Typography>
                <Grid sx={appVersionModalStyles.dialogVersionContainer}>
                    <Typography sx={appVersionModalStyles.infoLabel}>
                        UI Version {appVersion}
                    </Typography>
                    <Typography sx={appVersionModalStyles.infoLabel}>
                        UI Library Version {libraryVersion}
                    </Typography>
                    <Typography sx={appVersionModalStyles.infoLabel}>
                        Server Version {serverVersion}
                    </Typography>
                </Grid>
            </DialogContent>
            <DialogActions sx={appVersionModalStyles.dialogBodyContainer}>
                <Button
                    autoFocus
                    onClick={handleClose}
                    color='primary'
                    variant='contained'
                    sx={appVersionModalStyles.closeButton}
                >
                    CLOSE
                </Button>
            </DialogActions>
        </Dialog>
    );
};
